import { Box, FormControlLabel, IconButton, Tooltip, Typography } from "@mui/material"
import { useTranslation } from "react-i18next"
import { useStyles } from "./styles"
import { ModelDownloadButtons } from "../../../../../../components/donwloadFiles/model"
import { icons } from "../../../../../../utils/icons"
import { useTables } from "./hooks/useTable"
import { BaseMenu, CustomTable, SnackSimple } from "../../../../../../components"
import { DrawerEvidences } from "../../../../../../components/evidences"
import { useEvidencesType } from "../../../../../../hooks/evidences/useEvidences"
import React, { useMemo, useState } from "react"
import { DinamicForm } from "../../../../../../components/dinamicForm"
import { useCreatEdit } from "./hooks/useForm"
import { generalDisabled } from "../../../../../../utils/validate/validate"
import { EvidenceData, EvidenceOptionType } from "../../../../../../hooks/evidences/typyng"
import { FiltersDrawer } from "../../../../../../components/filtersDrawer"
import SimpleModal from "../../../../../../components/modal/simpleModal"
import { convertEvideceArray, getEvidenceData } from "../../../../../questionnaire/pages/detail/methods"
import { EvidenceTypeBody } from "../../../../../../service/questionarie/bodys"
import { loogbookServiceFetch } from "../../../../../../utils/constants/callService"
import { Types } from "../../../../../../utils/enums"
import Loader from "../../../../../../components/loader"
import { IOSSwitch } from "../../../../../../components/dynamicFormRef/switch"


export const ActivitiesCatalog = React.memo(() => {

    const { t } = useTranslation()
    const styles = useStyles()
    const [canEdit, setCanEdit] = useState(false)
    const evidencesActivity = useEvidencesType({})
    const [openField, setopenField] = useState(false)
    const { onChangeCrud, dataCrud, handledataCrud } = useCreatEdit()
    const { column: rawColumn, downloadMain, row: rawRow, getActivities, menu, optionMenu, settingData, closeMenu, inputCrud, inputFilter, filter, loading, closeModal, openModal, closeSnackbar, openSnackbar, setOpenSnackbar, totalPages } = useTables({ setCanEdit, evidencesActivity, handledataCrud, setopenField })
    const disableCrudForm = useMemo(() => generalDisabled(inputCrud, dataCrud), [dataCrud])

    const column = useMemo(() => rawColumn, [rawColumn]);
    const row = useMemo(() => rawRow, [rawRow]);

    const createOrEditActivity = async (data: EvidenceData[]) => {

        evidencesActivity?.saveEvidence(data || []);
        const questionEvidence = convertEvideceArray([...data])
        /* const questionEvidence = convertEvideceArray([...evidencesActivity.evidencesData]) */
        const evidenceData = getEvidenceData({ evidenceType: questionEvidence as any })
        setopenField(false)

        const body: { title: string, openField?: boolean, configTypeActivityEvidenceTypes: EvidenceTypeBody[] } = { title: String(dataCrud.activityName), openField: openField, configTypeActivityEvidenceTypes: evidenceData }

        if (canEdit) {
            /* const bodyToUpdate = { ...body };
            delete bodyToUpdate.openField; */
            const response = await loogbookServiceFetch.updateActivity(body, Number(dataCrud.idActivity))
            if (!response?.errors) {
                setOpenSnackbar(prev => ({ ...prev, type: Types.SUCCESS, message: t('loogbook.snackbar.catalog.update.success'), open: true }))
            } else {
                setOpenSnackbar(prev => ({ ...prev, type: Types.ERROR, message: t('loogbook.snackbar.catalog.update.error'), open: true }))
            }
        } else {
            const response = await loogbookServiceFetch.createActivity(body)
            if (!response?.errors) {
                setOpenSnackbar(prev => ({ ...prev, type: Types.SUCCESS, message: t('loogbook.snackbar.catalog.create.success'), open: true }))
            } else {
                setOpenSnackbar(prev => ({ ...prev, type: Types.ERROR, message: t('loogbook.snackbar.catalog.create.error'), open: true }))
            }
        }


        getActivities()

        handledataCrud()
        evidencesActivity.fillData({ defaultValues: [] })
    };

    const config = (value: boolean) => {
        setopenField(value)
    }


    return (
        <Box sx={styles.positionFilter}>
            <Box sx={styles.header}>
                <Typography variant="title_grey_big">{t('loogbook.titles.catalogueOfActivities')}</Typography>

                <Box sx={styles.flex}>

                    <SnackSimple
                        close={downloadMain.closeOpenSnakbar}
                        open={downloadMain.openSnackbar.open}
                        type={downloadMain.openSnackbar.type}
                        message={downloadMain.openSnackbar.message}
                    />

                    <ModelDownloadButtons
                        csv={downloadMain.downloadCSV}
                        pdf={downloadMain.downloadPDF}
                        word={downloadMain.downloadWORD}
                        disableCSV={downloadMain.download?.excel}
                        disablePDF={downloadMain.download?.pdf}
                        disableWORD={downloadMain.download?.word}
                    /* styleType 
                    disableTypes={['word']}  */
                    />

                    <Tooltip title={t('ToolTips.create')}>
                        <IconButton
                            sx={styles.add}
                            onClick={() => {
                                evidencesActivity.clickOption({})
                                setCanEdit(false)
                                handledataCrud()
                                evidencesActivity.fillData({ defaultValues: [] })
                                setopenField(false)
                            }}
                        >
                            {icons('add')}
                        </IconButton>
                    </Tooltip>

                    <FiltersDrawer cleanFilter={filter.cleanFilter} count={filter.counter} right={-74} top={-73}>
                        <Box sx={styles.section}>
                            <DinamicForm input={Object.values(inputFilter)} values={filter.filterData} onChange={filter.onChange} errors={filter.errors} filter={true} />
                        </Box>
                    </FiltersDrawer>
                </Box>
            </Box>

            <BaseMenu
                sx={[styles.baseMenu, settingData?.positionxy ?? { left: '-200%' }]}
                anchorEl={settingData?.e?.target ?? null}
                setAnchorEl={closeMenu}
                menuItems={menu}
                click={(item) => {
                    optionMenu({ item })
                }}
            />

            <CustomTable
                serverSidePagination={{ page: filter.paginationModel.page + 1, size: filter.paginationModel.pageSize, totalPages }}
                handleChange={(page: number, pageSize: number) => {
                    filter.handlePagination({ page, pageSize })
                }}
                order={
                    filter?.query.sort && {
                        count: filter.query?.sort?.count,
                        key: filter.query?.sort?.field,
                        order: filter.query?.sort?.sort,
                    }
                }
                sortable={(field, sort, count) => {
                    filter.sortTable(field && sort ? { field: field, sort: sort, count } : undefined)
                }}
                loader={loading.table}
                name="Informe General"
                dontRefresh
                column={column}
                row={row}
                selected={-1}
            />

            <DrawerEvidences
                disabledField={false/* canEdit */}
                /* headerLabel={t('general.returnreportFolioConfig')} */
                headerElement={
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                        <Typography sx={styles.titleEvidences}>{!canEdit ? t('loogbook.titles.newTypeOfActivity') : t('loogbook.titles.typeOfActivity')}</Typography>
                        {loading.search
                            ? (<Loader />) :
                            (<>
                                <DinamicForm input={Object.values(inputCrud)} onChange={onChangeCrud} values={dataCrud} />
                                <FormControlLabel
                                    sx={{ '& .MuiFormControlLabel-label': { fontSize: '0.9rem' }, marginBottom: 2 }}
                                    control={
                                        <IOSSwitch
                                            name="notified"
                                            checked={openField}
                                            onChange={({ target }) => {
                                                config(target.checked)
                                            }}
                                            sx={{ m: 1 }}
                                        />
                                    }
                                    label={t('loogbook.inputs.freeTextSpecification')}
                                />
                            </>)
                        }

                    </Box>
                }
                optionType={EvidenceOptionType.ACTIVITY_MANAGEMENT}
                refsByKey={evidencesActivity?.refsByKey}
                defaultValues={evidencesActivity?.evidencesData}
                open={!!evidencesActivity?.openEvidenceDrawer}
                setRef={evidencesActivity?.setRef}
                save={(data) => {
                    createOrEditActivity(data ?? [])
                }}
                cancel={() => {
                    evidencesActivity?.cancelEvidence()
                }}
                disabledButon={disableCrudForm}
            />
            <SimpleModal
                open={openModal.open}
                close={() => {
                    closeModal()
                }}
                title={openModal.title}
                description={openModal.description}
                buttonText={t('general.confirm')}
                cancelText={t('general.cancel')}
                back={() => {
                    closeModal()
                }}
                next={() => {
                    if (openModal?.confirm) {
                        openModal.confirm()
                    }
                }}
            />
            <SnackSimple
                close={closeSnackbar}
                open={openSnackbar.open}
                type={openSnackbar.type}
                message={openSnackbar.message}
            />
        </Box>
    )
})